module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "calibre1",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_vm._v("THE WORLD'S")]), _vm._v(" "), _c('h1', {
    staticClass: "calibre1",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_vm._v("GREATEST")]), _vm._v(" "), _c('h1', {
    staticClass: "calibre1",
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_vm._v("BOOKS")]), _vm._v(" "), _c('h2', {
    staticClass: "sigilnotintoc",
    attrs: {
      "id": "pgepubid00003"
    }
  }, [_vm._v("JOINT EDITORS")]), _vm._v(" "), _c('h3', {
    staticClass: "sigilnotintoc1",
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_vm._v("ARTHUR MEE")]), _vm._v(" "), _c('h4', {
    staticClass: "sigilnotintoc2",
    attrs: {
      "id": "pgepubid00005"
    }
  }, [_vm._v("Editor and Founder of the Book of Knowledge")]), _vm._v(" "), _c('h3', {
    staticClass: "sigilnotintoc1",
    attrs: {
      "id": "pgepubid00006"
    }
  }, [_vm._v("J. A. HAMMERTON")]), _vm._v(" "), _c('h4', {
    staticClass: "sigilnotintoc2",
    attrs: {
      "id": "pgepubid00007"
    }
  }, [_vm._v("Editor of Harmsworth's Universal Encyclopaedia")]), _vm._v(" "), _c('h3', {
    staticClass: "sigilnotintoc1",
    attrs: {
      "id": "pgepubid00008"
    }
  }, [_vm._v("VOL. III")]), _vm._v(" "), _c('h3', {
    staticClass: "sigilnotintoc1",
    attrs: {
      "id": "pgepubid00009"
    }
  }, [_vm._v("FICTION")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6b4f454","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section0001.vue
// module id = 57
// module chunks = 0